/* app/js/src/components/external-mam/external-mam-gateway-playground/search-grid-components/external-mam-search-results-status-cell/external-mam-search-results-status-cell.component.scss */
.cursor-pointer {
  cursor: pointer;
}
svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
svg.imported {
  fill: rgb(45, 187, 252);
}
/*# sourceMappingURL=external-mam-search-results-status-cell.component.css.map */
